import React, { useState, useEffect } from 'react';
import './index.css';
import { generate_presigned_urls } from '../common';
import { custom_post, post } from '../../utils/api';

interface ExistingFile {
    id: number;
    file_name: string;
    type: string;
    url: string;
    image_id: string;
}

interface FileUploaderProps {
    module: any;
    primary_id: string | undefined;
    FilesData: ExistingFile[]; // Preloaded files
    onFileChange: (files: any[]) => void; // Callback for updated file list
}

const FileInput: React.FC<FileUploaderProps> = (props) => {
    const [files, setFiles] = useState<any[]>(props.FilesData || []);
    const [new_files, setNewFiles] = useState<any[]>([]);

    useEffect(() => {
        // Update state if props.FilesData changes
        setFiles(props.FilesData || []);
        console.log("props.FilesData", props.FilesData)
        console.log("props.datttt", props)

    }, [props.FilesData]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const selectedFiles = Array.from(event.target.files);

            const newFiles = selectedFiles.map((file) => ({
                file, // The actual File object
                name: file.name,
                type: file.type,
            }));

            const updatedFiles = [...files, ...newFiles];
            // setFiles(updatedFiles);
            setNewFiles(newFiles)
            // props.onFileChange(updatedFiles);

            const fileNames = selectedFiles.map((file) => file.name);
            generate_presigned_urls(props.FilesData,fileNames, selectedFiles, props, 'edit');
        }
    };
    // const handleDownloadFile = async (fileObj:any,event: any) => {
    //     event.preventDefault(); // Prevents any default action like navigation

    //     console.log("fileObj", fileObj);
    //     let data:any = {...fileObj}
    //     data["bucketName"]='tangent-private';
    //     data["folderName"]='clients';
    //     console.log("urls_rdataesp", data)

    //     const urls_resp: any = await custom_post(`s3DownloadImage/${fileObj.id}`, data);
    //     console.log("urls_resp", urls_resp)
    //     const link = document.createElement('a');
    //     link.href = urls_resp.url ;
    //     link.download = fileObj.urls_resp || fileObj.urls_resp; // Set filename for download
    //     link.click();
    // };



    const handleDownloadFile = async (fileObj: any, event: any) => {
        event.preventDefault(); // Prevents default navigation or actions
     
        console.log("fileObj", fileObj);
     
        let data: any = { ...fileObj };
        data["bucketName"] = 'nautai-marine';
        data["folderName"] = 'job_enquiries';
     
        console.log("data to send", data);
     
        try {
            // Make API call to get the file's pre-signed URL or download link
            const urls_resp: any = await custom_post(`s3DownloadImage/${props.primary_id}`, data);
     
            console.log("urls_resp", urls_resp);
            let url: any = urls_resp.url; // Ensure this is the correct pre-signed URL
     
            // Fetch the file as a blob for direct download
            const response = await fetch(url);
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to fetch file: ${response.statusText}, ${errorText}`);
            }
            const blob = await response.blob();
     
            // Create a temporary URL for the blob
            const blobUrl = window.URL.createObjectURL(blob);
     
            // Create a temporary anchor element to trigger the download
            const anchor = document.createElement('a');
            anchor.href = blobUrl;
            anchor.download = fileObj.file_name || 'downloaded_file'; // Set default file name if not provided
            document.body.appendChild(anchor); // Append anchor to body
            anchor.click(); // Programmatically click the anchor
            document.body.removeChild(anchor); // Remove anchor after download
     
            // Revoke the blob URL to release memory
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Error during file download:", error);
        }
    };
    






    // const handleDownloadFile = async (fileObj: any, event: any) => {
    //     event.preventDefault(); // Prevents default navigation or actions
    
    //     console.log("fileObj", fileObj);
    
    //     let data: any = { ...fileObj };
    //     data["bucketName"] = 'nautai-marine';
    //     data["folderName"] = 'job_enquiries';
    
    //     console.log("data to send", data);
    
    //     try {
    //         // Make API call to get the file's pre-signed URL or download link
    //         const urls_resp: any = await custom_post(`s3DownloadImage/${fileObj.id}`, data);
    
    //         console.log("urls_resp", urls_resp);
    //         let url: any = urls_resp.url;
    
    //         // Fetch the file as a blob for direct download
    //         const response = await fetch(url);
    //         if (!response.ok) {
    //             throw new Error(`Failed to fetch file: ${response.statusText}`);
    //         }
    //         const blob = await response.blob();
    
    //         // Create a temporary URL for the blob
    //         const blobUrl = window.URL.createObjectURL(blob);
    
    //         // Create a temporary anchor element to trigger the download
    //         const anchor = document.createElement('a');
    //         anchor.href = blobUrl;
    //         anchor.download = fileObj.file_name || 'downloaded_file'; // Set default file name if not provided
    //         document.body.appendChild(anchor); // Append anchor to body
    //         anchor.click(); // Programmatically click the anchor
    //         document.body.removeChild(anchor); // Remove anchor after download
    
    //         // Revoke the blob URL to release memory
    //         window.URL.revokeObjectURL(blobUrl);
    //     } catch (error) {
    //         console.error("Error during file download:", error);
    //     }
    // };
    
    
    const handleRemoveFile = (index: number, event:any) => {
        event.preventDefault(); // Prevents any default action like navigation

        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
        props.onFileChange(updatedFiles);
    };

    return (
        <div className="file-uploader-premium">
            <input
                type="file"
                multiple
                onChange={handleFileChange}
                id="file-input"
                className="file-input"
            />
            <label htmlFor="file-input" className="file-label">
                Add Files
            </label>

            {files.length > 0 && (
                <div className="file-list">
                    <h3>Uploaded Files:</h3>
                    <ul>
                        {files.map((fileObj:any, index:any) => (
                            <li key={index} className="file-item">
                                {/* Handle preloaded files with URL */}
                                {/* {fileObj.image_id && fileObj.url ? (
                                    <img
                                        src={fileObj.url}
                                        alt={fileObj.file_name}
                                        style={{
                                            height: '50px',
                                            width: '50px',
                                            objectFit: 'cover',
                                            marginRight: '10px',
                                        }}
                                    />
                                ) : fileObj.file && fileObj.type.startsWith('image/') ? (
                                    <img
                                        src={URL.createObjectURL(fileObj.file)}
                                        alt={fileObj.file_name}
                                        style={{
                                            height: '50px',
                                            width: '50px',
                                            objectFit: 'cover',
                                            marginRight: '10px',
                                        }}
                                    />
                                ) : (
                                    <span>{fileObj.name || fileObj.file_name}</span>
                                )} */}

                                <span>{fileObj.file_name || fileObj.name}</span>

                                <button
                                    className="remove-file-button"
                                    onClick={(event) => handleRemoveFile(index, event)} // Prevent navigation
                                >
                                    Remove
                                </button>

                                <button
                                    className="download-file-button"
                                    onClick={(event) => handleDownloadFile(fileObj,event)} // Download file
                                >
                                    Download
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );

    // return (
    //     <div className="file-uploader-premium">
    //         <input
    //             type="file"
    //             multiple
    //             onChange={handleFileChange}
    //             id="file-input"
    //             className="file-input"
    //         />
    //         <label htmlFor="file-input" className="file-label">
    //             Add Files
    //         </label>

    //         {files.length > 0 && (
    //             <div className="file-list">
                    
    //                 <h3>Uploaded Files:</h3>
    //                 <ul>
    //                     {files.map((fileObj: any, index) => (
    //                         <li key={index} className="file-item">
    //                             {fileObj.file_name && fileObj.url ? (
    //                                 <img
    //                                     src={fileObj.url}
    //                                     alt={fileObj.file_name}
    //                                     style={{
    //                                         height: '50px',
    //                                         width: '50px',
    //                                         objectFit: 'cover',
    //                                         marginRight: '10px',
    //                                     }}
    //                                 />
    //                             ) : fileObj.file && fileObj.type.startsWith('image/') ? (
    //                                 <img
    //                                     src={URL.createObjectURL(fileObj.file)}
    //                                     alt={fileObj.name}
    //                                     style={{
    //                                         height: '50px',
    //                                         width: '50px',
    //                                         objectFit: 'cover',
    //                                         marginRight: '10px',
    //                                     }}
    //                                 />
    //                             ) : (
    //                                 <span>{fileObj.name || fileObj.file_name}</span>
    //                             )}
    //                             {fileObj.file_name || fileObj.name}
    //                             <button
    //                                 className="remove-file-button"
    //                                 onClick={(event:any) => handleRemoveFile(index, event)}  // Prevent navigation

    //                             >
    //                                 Remove
    //                             </button>
    //                         </li>
    //                     ))}
    //                 </ul>
    //             </div>
    //         )}
    //     </div>
    // );
};

export default FileInput;





// import React, { useState } from 'react';
// import './index.css';
// import { custom_post } from '../../utils/api';
// import { generate_presigned_urls } from '../common';

// interface FileUploaderProps {
//     module: any;
//     primary_id: string | undefined;
//     FilesData: any[]; // This should be an array of uploaded file information
//     onFileChange: (files: any[]) => void; // Accept an array of objects containing file details
// }

// const FileInput: React.FC<FileUploaderProps> = (props) => {
//     const [files, setFiles] = useState<any[]>(props.FilesData || []);

//     console.log("files%%%%%", props.FilesData)
//     const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//         if (event.target.files) {
//             const selectedFiles = Array.from(event.target.files);
//             setFiles(selectedFiles);
//             const fileNames = selectedFiles.map((file) => file.name);
//             generate_presigned_urls(fileNames, selectedFiles, props, 'edit');
//         }
//     };

//     const handleRemoveFile = (index: number) => {
//         setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
//     };

//     return (
//         <div className="file-uploader-premium">
//             <input
//                 type="file"
//                 multiple
//                 onChange={handleFileChange}
//                 id="file-input"
//                 className="file-input"
//             />
//             <label htmlFor="file-input" className="file-label">
//                 Select Files
//             </label>

//             {files.length > 0 && (
//                 <div className="file-list">
//                     <h3>Selected Files:</h3>
//                     <ul>
//                         {files.map((file:any, index) => (
//                             <li key={index} className="file-item">
//                                 {/* Show image preview for image files */}
//                                 {file.type.startsWith('image/') && (
//                                     <img
//                                         src={URL.createObjectURL(file)}
//                                         alt={file.name}
//                                         style={{
//                                             height: '50px',
//                                             width: '50px',
//                                             objectFit: 'cover',
//                                             marginRight: '10px',
//                                         }}
//                                     />
//                                 )}
//                                 {file.name}
//                                 <button
//                                     className="remove-file-button"
//                                     onClick={() => handleRemoveFile(index)}
//                                 >
//                                     Remove
//                                 </button>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             )}
//         </div>
//     );
// };

//export default FileInput;












// import React, { useState } from 'react';
// import './index.css';
// import { custom_post } from '../../utils/api';
// import { generate_presigned_urls } from '../common';

// interface FileUploaderProps {
//     module: any;
//     primary_id: string | undefined;
//     FilesData: any[]; // This should be an array of uploaded file information
//     onFileChange: (files: any[]) => void; // Accept an array of objects containing file details
// }

// const FileInput: React.FC<FileUploaderProps> = (props) => {
//     const [files, setFiles] = useState<File[]>(props.FilesData || []);
    
//     const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//         if (event.target.files) {
//             const selectedFiles = Array.from(event.target.files);
//             setFiles(selectedFiles);
//             const fileNames = selectedFiles.map((file) => file.name);
//             generate_presigned_urls(fileNames, selectedFiles, props, 'edit');
//         }
//     };

//     // const generate_presigned_urls = async (file_names: string[], selectedFiles: File[]) => {
//     //     console.log("77777", props.module)
//     //     const data = {
//     //         bucketName: 'tangent-private',
//     //         folderName: props.module,
//     //         fileNames: file_names,
//     //     };

//     //     try {
//     //         const urls_resp: any = await custom_post(`s3PresignedUrls/${props.primary_id}`, data);
//     //         let updated_files: any[] = [];
//     //         if (urls_resp && Array.isArray(urls_resp.urls) && urls_resp.urls.length > 0) {
//     //             await Promise.all(selectedFiles.map(async (file: File, index: number) => {
//     //                 if (index < urls_resp.urls.length) {
//     //                     const uploadUrl = urls_resp.urls[index];
//     //                     let obj = {
//     //                         id: (index + 1),
//     //                         file_name: file.name,
//     //                         type: file.type,
//     //                         url: uploadUrl
//     //                     }
//     //                     updated_files.push(obj);
//     //                     await uploadFileToS3(file, uploadUrl);
//     //                 } else {
//     //                     console.error("No URL available for file:", file.name);
//     //                 }
//     //             }));
//     //             // Call onFileChange with updated files after all uploads are complete
//     //             props.onFileChange(updated_files);
//     //         } else {
//     //             console.error("No valid URLs returned from the API.");
//     //         }
//     //     } catch (error) {
//     //         console.error("Error loading data:", error);
//     //     }
//     // };

//     // const uploadFileToS3 = async (file: File, url: string) => {
//     //     try {
//     //         const response = await fetch(url, {
//     //             method: "PUT",
//     //             headers: {
//     //                 "Content-Type": file.type,
//     //             },
//     //             body: file,
//     //         });

//     //         if (!response.ok) {
//     //             throw new Error(`Failed to upload ${file.name} to S3`);
//     //         }
//     //         console.log(`${file.name} uploaded successfully!`);
//     //     } catch (error) {
//     //         console.error(`Error uploading ${file.name}:`, error);
//     //     }
//     // };

//     const handleRemoveFile = (index: number) => {
//         setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
//     };

//     return (
//         <div className="file-uploader-premium">
//             <input
//                 type="file"
//                 multiple
//                 onChange={handleFileChange}
//                 id="file-input"
//                 className="file-input"
//             />
//             <label htmlFor="file-input" className="file-label">
//                 Select Files
//             </label>

//             {files.length > 0 && (
//                 <div className="file-list">
//                     <h3>Selected Files:</h3>
//                     <ul>
//                         {files.map((file, index) => (
//                             <li key={index} className="file-item">
//                                 {file.name}
//                                 <button
//                                     className="remove-file-button"
//                                     onClick={() => handleRemoveFile(index)}
//                                 >
//                                     Remove
//                                 </button>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default FileInput;
